import VideoPlayer from '../../components/videoPlayer/videoPlayer';

export default class TopSection {
    constructor() {
        this.videoPlayer = new VideoPlayer();
    }
}



// WEBPACK FOOTER //
// ./src/components/topSection/topSection.js